import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_id = z.any()
export type TagsGetAdminBuildings_id = z.infer<typeof tagsGetAdminBuildings_id>

export const paramsGetAdminBuildings_id = z.object({ "id": z.string() })
export type ParamsGetAdminBuildings_id = z.infer<typeof paramsGetAdminBuildings_id>

export const responseGetAdminBuildings_id = z.object({ "payload": z.object({ "building": z.object({ "id": z.string().max(191), "name": z.string().max(255), "municipalityId": z.string().max(255), "address": z.union([z.string().max(255), z.null()]), "image": z.union([z.string().max(255), z.null()]), "isPublicLightning": z.boolean(), "order": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) }), "municipality": z.object({ "id": z.string(), "name": z.string() }), "collectionPoints": z.array(z.object({ "id": z.string().max(191), "buildingId": z.string().max(255), "name": z.string().max(255), "type": z.union([z.literal("electricity"), z.literal("gas"), z.literal("water"), z.literal("coal"), z.literal("heat"), z.literal("other")]), "identifier": z.string().max(255), "customType": z.union([z.string().max(100), z.null()]), "supplier": z.union([z.string().max(255), z.null()]), "price": z.union([z.string(), z.null()]), "singleRateTariff": z.boolean(), "meterCodes": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "gasCalorificValue": z.union([z.string(), z.null()]), "gasVolumeCoefficient": z.union([z.string(), z.null()]), "consumptionReminderEnabled": z.boolean(), "consumptionReminderStartDate": z.union([z.string(), z.null()]), "consumptionReminderFrequency": z.union([z.literal("weekly"), z.literal("monthly"), z.literal("yearly")]), "order": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) })), "invoices": z.array(z.object({ "id": z.string().max(191), "collectionPointId": z.string().max(255), "periodFrom": z.union([z.string(), z.null()]), "periodTo": z.union([z.string(), z.null()]), "identifier": z.string().max(255), "meterCode": z.union([z.string().max(255), z.null()]), "distributionRate": z.union([z.string().max(50), z.null()]), "breaker": z.union([z.string().max(10), z.null()]), "consumptionVT": z.string(), "consumptionNT": z.string(), "fileProcessId": z.union([z.string().max(255), z.null()]), "createdBy": z.union([z.string().max(255), z.null()]), "distributor": z.union([z.string().max(255), z.null()]), "priceVTWithoutTax": z.string(), "priceVTWithTax": z.string(), "priceNTWithoutTax": z.string(), "priceNTWithTax": z.string(), "recurringPaymentWithoutTax": z.union([z.string(), z.null()]), "recurringPaymentWithTax": z.union([z.string(), z.null()]), "electricityTaxWithoutTax": z.union([z.string(), z.null()]), "electricityTaxWithTax": z.union([z.string(), z.null()]), "pricePerMeterWithoutTax": z.union([z.string(), z.null()]), "pricePerMeterWithTax": z.union([z.string(), z.null()]), "consumptionGeneric": z.string(), "priceGenericWithoutTax": z.union([z.string(), z.null()]), "priceGenericWithTax": z.union([z.string(), z.null()]), "pricePerBreakerWithoutTax": z.union([z.string(), z.null()]), "pricePerBreakerWithTax": z.union([z.string(), z.null()]), "distributionPriceWithoutTax": z.union([z.string(), z.null()]), "distributionPriceWithTax": z.union([z.string(), z.null()]), "gasCalorificValue": z.union([z.string(), z.null()]), "gasVolumeCoefficient": z.union([z.string(), z.null()]), "gasConsumptionM3": z.union([z.string(), z.null()]), "itemsJson": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]), "fileNames": z.array(z.string()).optional() })), "consumptions": z.array(z.object({ "id": z.string().max(191), "collectionPointId": z.string().max(255), "consumptionNT": z.string(), "consumptionVT": z.string(), "number": z.string().max(255), "fileProcessId": z.union([z.string().max(255), z.null()]), "consumptionGeneric": z.string(), "meterChange": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "invoiceId": z.union([z.string().max(255), z.null()]), "createdBy": z.union([z.string().max(255), z.null()]), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuildings_id = z.infer<typeof responseGetAdminBuildings_id>

interface IGetAdminBuildings_id extends BaseMethodType {
  tags: TagsGetAdminBuildings_id,
  params: ParamsGetAdminBuildings_id,
  response: ResponseGetAdminBuildings_id
}
export const tagsPatchAdminBuildings_id = z.any()
export type TagsPatchAdminBuildings_id = z.infer<typeof tagsPatchAdminBuildings_id>

export const paramsPatchAdminBuildings_id = z.object({ "id": z.string() })
export type ParamsPatchAdminBuildings_id = z.infer<typeof paramsPatchAdminBuildings_id>

export const bodyPatchAdminBuildings_id = z.object({ "name": z.string().optional(), "address": z.string().optional() })
export type BodyPatchAdminBuildings_id = z.infer<typeof bodyPatchAdminBuildings_id>

export const responsePatchAdminBuildings_id = z.object({ "payload": z.object({ "id": z.string().max(191), "name": z.string().max(255), "municipalityId": z.string().max(255), "address": z.union([z.string().max(255), z.null()]), "image": z.union([z.string().max(255), z.null()]), "isPublicLightning": z.boolean(), "order": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminBuildings_id = z.infer<typeof responsePatchAdminBuildings_id>

interface IPatchAdminBuildings_id extends BaseMethodType {
  tags: TagsPatchAdminBuildings_id,
  params: ParamsPatchAdminBuildings_id,
  body: BodyPatchAdminBuildings_id,
  response: ResponsePatchAdminBuildings_id
}
export const URL = '/admin/buildings/:id'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_id,
    params: paramsGetAdminBuildings_id,
    response: responseGetAdminBuildings_id
  },
  patch: {
    tags: tagsPatchAdminBuildings_id,
    params: paramsPatchAdminBuildings_id,
    body: bodyPatchAdminBuildings_id,
    response: responsePatchAdminBuildings_id
  }
}
export interface AdminBuildings_id extends BaseRouteType {
  get: IGetAdminBuildings_id,
  patch: IPatchAdminBuildings_id
}